import { Activity, ActivityState, Organization, AccountState, Account, ServerEventsActions } from '@app/_store';
import { Component, OnInit, HostListener, inject, ChangeDetectionStrategy } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { Store } from '@ngxs/store';
import { OrganizationActions, OrganizationState } from './_store';
import { PreviousRouteService } from './_helpers';
import { NewVersionService } from './_services/new-version.service';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'app',
  templateUrl: 'app.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  // Still declared in AppModule, which bootstraps it together with MsalRedirectComponent
  // eslint-disable-next-line @angular-eslint/prefer-standalone
  standalone: false,
})
export class AppComponent implements OnInit {
  componentDestroyed$: Subject<boolean> = new Subject<boolean>();

  account$: Observable<Account> = inject(Store).select(AccountState.account);
  currentOrganization$: Observable<Organization> = inject(Store).select(OrganizationState.current);
  currentActivity$: Observable<Activity> = inject(Store).select(ActivityState.currentActivity);

  constructor(
    private store: Store,
    previousRouteService: PreviousRouteService,
    newVersionService: NewVersionService
  ) {
    previousRouteService.startMonitor();
    newVersionService.startMonitor();
  }

  @HostListener('document:visibilitychange')
  visibilitychange() {
    if (!document.hidden) this.store.dispatch(new ServerEventsActions.CheckConnection());
  }

  ngOnInit(): void {
    let current: Account;
    this.account$.subscribe(account => {
      let loadOrganizations = false;

      if (account) {
        if (current == null) {
          loadOrganizations = true;
        } else {
          loadOrganizations = account.organizations?.length !== current.organizations?.length;
        }
      }

      if (loadOrganizations) {
        this.store.dispatch(new OrganizationActions.LoadAll());
      }
      current = account;
    });
  }
}
